import { ActionType, getType } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { EntityMapState } from '../../types/state/entities/EntityMapState';
import { UserSlim } from '../../types/account/UserSlim';
import { cloManagerUsersActions } from '../../actions/entities/cloManagerUsers.actions';
import { apiUtils } from '../../utils';

export const cloManagerUsersDefaultState: EntityMapState<number, UserSlim> = {
    items: {},
    requestState: RequestState.none,
};

export type CloManagerUsersActionTypes = ActionType<typeof cloManagerUsersActions[keyof typeof cloManagerUsersActions]>;

export function cloManagerUsersReducer(
    state = cloManagerUsersDefaultState,
    action: CloManagerUsersActionTypes,
): EntityMapState<number, UserSlim> {
    switch (action.type) {
        case getType(cloManagerUsersActions.request):
            return { ...state, requestState: action.payload.requestState };
        case getType(cloManagerUsersActions.response):
            return {
                requestState: action.payload.requestState,
                items: apiUtils.normalize(action.payload.users, u => u.id, u => u),
            };
        default:
            return state;
    }
}
